module.exports = __webpack_public_path__ + "static/media/bar3.4f51447d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floorPlan/bar3.svg
// module id = 1125
// module chunks = 38